import { FaUserCircle, FaBell } from "react-icons/fa";
import { useQuery } from "react-query";
import { apiConnectorGet } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const { data: profile } = useQuery(
    ["get_profile"],
    () => apiConnectorGet(endpoint?.profile_api),
    {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  );

  const user_profile = profile?.data?.result?.[0] || {};

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl border-b border-[#1e3a5f]/60"
      style={{ background: "linear-gradient(90deg, rgba(6,14,28,0.97) 0%, rgba(8,15,28,0.97) 100%)" }}>
      {/* Top accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#2563EB]/60 to-transparent" />

      <div className="flex items-center justify-between px-4 sm:px-6 h-14">
        {/* Left */}
        <div className="flex items-center gap-3">
          {/* Live indicator */}
          <div className="hidden sm:flex items-center gap-2 bg-[#2563EB]/10 border border-[#2563EB]/20 rounded-full px-3 py-1">
            <span className="w-1.5 h-1.5 rounded-full bg-[#22D3EE] animate-pulse block"></span>
            <span className="text-[10px] text-[#7DD3FC] font-semibold tracking-widest uppercase">Live</span>
          </div>
        </div>

        {/* Right */}
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Notification bell */}
          <button className="relative w-9 h-9 rounded-xl flex items-center justify-center border border-[#1e3a5f]/60 hover:border-[#2563EB]/40 hover:bg-[#2563EB]/10 transition-all duration-200 text-[#475569] hover:text-[#7DD3FC]">
            <FaBell className="text-sm" />
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-[#2563EB]"></span>
          </button>

          {/* Divider */}
          <div className="w-px h-6 bg-[#1e3a5f]/60 hidden sm:block"></div>

          {/* User chip */}
          <button
            onClick={() => navigate("/profile")}
            className="flex items-center gap-2.5 bg-[#071526]/80 border border-[#1e3a5f]/60 hover:border-[#2563EB]/40 rounded-2xl px-3 py-1.5 transition-all duration-200 group"
          >
            <div className="w-7 h-7 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] flex items-center justify-center shadow-[0_0_10px_rgba(37,99,235,0.4)] flex-shrink-0">
              {user_profile?.rew_serial ? (
                <span className="text-white font-black text-xs">{String(user_profile.rew_serial).charAt(0).toUpperCase()}</span>
              ) : (
                <FaUserCircle className="text-white text-sm" />
              )}
            </div>
            <div className="hidden sm:block text-left">
              <p className="text-white text-xs font-semibold leading-none">
                {user_profile?.lgn_username || "User"}
              </p>
              <p className="text-[#475569] text-[10px] mt-0.5 leading-none">
                {user_profile?.lgn_cust_id || "—"}
              </p>
            </div>
            <svg className="w-3 h-3 text-[#475569] hidden sm:block group-hover:text-[#7DD3FC] transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
